import { render, staticRenderFns } from "./productMan.vue?vue&type=template&id=41ed2f4a&scoped=true&"
import script from "./productMan.vue?vue&type=script&lang=js&"
export * from "./productMan.vue?vue&type=script&lang=js&"
import style0 from "./productMan.vue?vue&type=style&index=0&id=41ed2f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed2f4a",
  null
  
)

export default component.exports